import { render, staticRenderFns } from "./ProductComp.vue?vue&type=template&id=07019b18&"
import script from "./ProductComp.vue?vue&type=script&lang=js&"
export * from "./ProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports